import React from 'react';

const Toggle = ({
  value,
  setValue,
  title,
  callback,
  name,
}) => {

  const handleOnChange = (e) => {
    if (callback) return callback(e);
    return setValue(e.target.value === '0');
  };

  return (
    <div className="flex justify-end w-full my-6 items-center">
      <label htmlFor={name || 'toggle'} className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">
        {title}
      </label>
      <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
        <input
          type="checkbox"
          name={name || 'toggle'}
          value={value ? 1 : 0}
          onChange={handleOnChange}
          checked={value ? 1 : 0}
          className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
        />
        <label htmlFor={name || 'toggle'} className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer"></label>
      </div>
    </div>
  );
};

export default Toggle;
